import { render, staticRenderFns } from "./SelfieSayCheese.vue?vue&type=template&id=123618a0"
import script from "./SelfieSayCheese.vue?vue&type=script&lang=js"
export * from "./SelfieSayCheese.vue?vue&type=script&lang=js"
import style0 from "./SelfieSayCheese.vue?vue&type=style&index=0&id=123618a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports